// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"acacbf72","584":"552860ea","815":"d62b4755"}[chunkId] + ".chunk.js";
};